import { useNavigate, useParams } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

type Success = {
	canRender: true;
	hotelID: string;
	reservationID: string;
};

type Failure = {
	canRender: false;
};

type ReturnType = Success | Failure;

export const useConfirmParams = (): ReturnType => {
	const { hotelID, reservationID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MANAGEMENT.RESERVATION.EDIT>>();

	const navigate = useNavigate();

	let canRender = true;

	/**
	 * @todo ブランク時の振る舞いを設計
	 */
	if (!hotelID || !reservationID) {
		canRender = false;
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);

		return {
			canRender,
		};
	}

	return {
		canRender,
		hotelID,
		reservationID,
	};
};
